var map = {
	"./Dark_theme.jpg": 4893,
	"./Earth_theme.jpg": 1468,
	"./Jupiter_theme.jpg": 7763,
	"./Light_theme.jpg": 2083,
	"./Mars_theme.jpg": 8786,
	"./Mercury_theme.jpg": 3897,
	"./Neptune_theme.jpg": 3450,
	"./Saturn_theme.jpg": 7940,
	"./Uranus_theme.jpg": 4448,
	"./Venus_theme.jpg": 4245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8017;